import React, { useState, useEffect } from 'react';
import { Field, formValueSelector, FieldArray } from 'redux-form';
import { FormGroup, Label, Button } from 'reactstrap';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';
import Repeater from '../../../system/fields/Repeater';
import DatePickerInput from '../../../system/fields/DatePicker';
import * as validations from '../../../system/utils/Validation';
import TextInput from '../../../system/fields/TextInput';
import Switch from '../../../system/fields/Switch';

const selector = formValueSelector('DealForm');

const ReUsableDate = ({
  eachDay,
  option,
  monthIndex,
  month_dates,
  dateIndex,
  optionIndex,
  optionsLength,
  dealId,
}) => {
  const baseDateValue =
    month_dates &&
    month_dates[monthIndex] &&
    month_dates[monthIndex].dates &&
    month_dates[monthIndex].dates[dateIndex]
      ? month_dates[monthIndex].dates[dateIndex]
      : null;
  return (
    <div>
      <div
        style={{
          padding: '0',
          overflow: optionIndex === 0 ? 'visible' : 'hidden',
          opacity: optionIndex === 0 ? 1 : 0,
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <div
          style={{
            marginBottom: '10px',
            marginTop: '10px',
            padding: 0,
            textAlign: 'center',
          }}
        >
          <Field
            name={`month_dates[${monthIndex}].dates[${dateIndex}].date_from`}
            dateFormat={'MMMM yyyy'}
            fieldName={'date_from'}
            dateType={'month'}
            placeholder='Select month'
            component={DatePickerInput}
            optionsLength={optionsLength}
            nextItemName={`month_dates[${monthIndex}].dates`}
            dateIndex={dateIndex}
            type='text'
            className='form-control'
          />
        </div>
      </div>

      <div
        style={{
          overflow: 'hidden',
          opacity: 0,
          height: 0,
          width: 0,
        }}
      >
        <FormGroup
          className={'col-sm-12'}
          style={{ marginBottom: 0, paddingBottom: 0 }}
        >
          <Field
            name={`month_dates[${monthIndex}].dates[${dateIndex}].date_from`}
            dateFormat={'MMMM yyyy'}
            fieldName={'date_from'}
            dateType={'month'}
            placeholder='Select month'
            component={DatePickerInput}
            type='text'
            className='form-control'
          />
        </FormGroup>
        <Field
          name={`month_dates[${monthIndex}].dates[${dateIndex}].date_to`}
          dateFormat={'MMMM yyyy'}
          fieldName={'date_from'}
          dateType={'month'}
          placeholder='Select month'
          component={DatePickerInput}
          type='text'
          className='form-control'
        />
        <Field
          name={`month_dates[${monthIndex}].dates[${dateIndex}].option_id`}
          component={TextInput}
          placeholder='Option ID'
          type='text'
          fieldName={'option_id'}
          customValue={option.id}
          value={option.id}
          defaultValue={option.id}
        />

        <Field
          name={`month_dates[${monthIndex}].dates[${dateIndex}].deal_id`}
          component={TextInput}
          placeholder='Deal ID'
          type='text'
          customValue={dealId}
          value={dealId}
          defaultValue={dealId}
          // value={option.id}
          // defaultValue={option.deal_id}
        />
      </div>

      <div
        style={{
          fontWeight: 'bold',
          fontSize: '1rem',
          textAlign: 'center',
          marginBottom: '10px',
        }}
      >
        <strong>{option.name}</strong>
      </div>

      <FormGroup
        className={'col-sm-12'}
        style={{ marginBottom: 0, paddingBottom: 0 }}
        row
      >
        <Label
          htmlFor='email'
          style={{ minWidth: '50px', textAlign: 'right', marginRight: '5px' }}
        >
          Inside
        </Label>
        <Field
          name={`month_dates[${monthIndex}].dates[${dateIndex}].indoor_price`}
          component={TextInput}
          placeholder='Price Per Person'
          type='text'
          defaultValue={baseDateValue && baseDateValue.indoor_price}
        />
      </FormGroup>

      <FormGroup
        row
        className={'col-sm-12'}
        style={{ marginBottom: 0, paddingBottom: 0 }}
      >
        <Label
          htmlFor='email'
          style={{ minWidth: '50px', textAlign: 'right', marginRight: '5px' }}
        >
          Outside
        </Label>
        <Field
          name={`month_dates[${monthIndex}].dates[${dateIndex}].outdoor_price`}
          component={TextInput}
          placeholder='Price Per Person'
          type='text'
          defaultValue={baseDateValue && baseDateValue.outdoor_price}
        />
      </FormGroup>
      <FormGroup
        row
        className={'col-sm-12'}
        style={{ marginBottom: 0, paddingBottom: 0 }}
      >
        <Label
          htmlFor='email'
          style={{ minWidth: '50px', textAlign: 'right', marginRight: '5px' }}
        >
          Balcony
        </Label>
        <Field
          name={`month_dates[${monthIndex}].dates[${dateIndex}].balcony_price`}
          component={TextInput}
          placeholder='Price Per Person'
          type='text'
          defaultValue={baseDateValue && baseDateValue.balcony_price}
        />
      </FormGroup>
      <FormGroup className={'col-sm-12'} row style={{ marginBottom: '10px' }}>
        <Label
          htmlFor='email'
          style={{ minWidth: '50px', textAlign: 'right', marginRight: '5px' }}
        >
          Suite
        </Label>
        <Field
          name={`month_dates[${monthIndex}].dates[${dateIndex}].suite_price`}
          component={TextInput}
          placeholder='Price Per Person'
          type='text'
          defaultValue={baseDateValue && baseDateValue.suite_price}
        />
      </FormGroup>
    </div>
  );
};

class Dates extends React.Component {
  constructor(props, date, index, fields) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      collapse: true,
      activeTab: 0,
      month_dates_in_props: this.props.month_dates,
    };

    this.toggleTab = this.toggleTab.bind(this);
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }
  toggleTab(tab) {
    //if (this.state.activeTab !== tab) {
    this.setState({
      activeTab: tab,
    });
    //}
  }
  componentDidMount;
  remove(index, spliceCount) {
    console.log(index, '!!!!!!!! REM<EO', this.props.fields);
    // console.log(this.props.fields.get(index).month_dates, '<==== dates');

    const result = window.confirm('Are you sure you want to remove this row?');
    if (result) {
      let _dates = this.props.month_dates[0].dates;
      _dates.splice(index, spliceCount);
      this.setState({
        month_dates: _dates,
      });
      // this.props.month_dates.remove(index);
      // console.log(this.props.fields.get(index), '<==== dates');
    }
  }

  render() {
    const options = this.props.options;
    const month_dates = this.props.month_dates;
    const dealId = this.props.match.params.id;
    console.log(this.props.month_dates, '!!!! MODA');
    return (
      <div
        className='top-field'
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${options && options.length}, 1fr)`,
        }}
      >
        {this.state &&
          this.props.month_dates &&
          this.props.month_dates[0] &&
          this.props.month_dates[0].dates &&
          this.props.month_dates[0].dates.map((date, j) => {
            let opIndex = options.findIndex(function (optn) {
              return optn.id === date.option_id;
            });

            if (opIndex >= 0) {
              return (
                <div
                  key={`mo-da-dex-${j}`}
                  style={{
                    flexDirection: 'row',
                    borderBottom: '1px solid #eaeaea',
                  }}
                >
                  {opIndex % 2 == 0 && (
                    <Button
                      color='danger'
                      outline
                      onClick={() => {
                        if (date) {
                          this.remove(j, options.length);
                        } else {
                          console.log('!!!!narp');
                        }
                      }}
                    >
                      <i className='far fa-trash-alt' />
                    </Button>
                  )}
                  {/* {options.map((option, m) => { */}
                  {/* return ( */}
                  <ReUsableDate
                    key={`${0}-and${j}`}
                    monthIndex={0}
                    eachDay={
                      date && date.dates && date.dates[j] && date.dates[j]
                    }
                    dateIndex={j}
                    optionsLength={options.length}
                    option={options[opIndex]}
                    optionIndex={opIndex}
                    month_dates={month_dates}
                    dealId={dealId}
                  />
                  {/* );
                })} */}
                </div>
              );
            }
          })}
        {this.props.month_dates &&
          this.props.month_dates[0] &&
          this.props.month_dates[0].dates && (
            <a
              className=' btn btn-success'
              onClick={() => {
                let opArray = options.map((eachOp) => {
                  this.setState({
                    month_dates: this.props.month_dates[0].dates.push({
                      deal_id: dealId,
                      option_id: eachOp.id,
                      option: eachOp,
                    }),
                  });
                  // return {
                  //   deal_id: dealId,
                  //   option_id: eachOp.id,
                  // };
                });
                // this.setState({
                //   month_dates: this.props.month_dates[0].dates.push(opArray),
                // });
              }}
            >
              Add date
            </a>
          )}
      </div>
    );
  }
}

const DatesWrapper = connect((state, props) => ({
  airport: selector(state, `${props.date}.airport`),
  options: selector(state, 'options'),
  month_dates: selector(state, 'month_dates'),
}))(Dates);

export default withRouter(DatesWrapper);



// WEBPACK FOOTER //
// ./src/containers/Deals/components/Dates.jsx